import React, { Component } from 'react';
import NavTools from '../../tools/NavTools';
import Constants from '../../game/constants/Constants';
import SoundRepository from '../../game/handlers/SoundRepository';

export default class PrevButton extends Component {

    constructor(props) {
        super(props);
        this.soundRepository = SoundRepository;
    }

    goBack = (pageProps) => {
        this.soundRepository.playSoundByName(Constants.SOUND_BUTTON);
        let prevUrl = '/';
        if (pageProps.location.state) {
            prevUrl = pageProps.location.state.prevState.prevUrl
        }
        NavTools.redirect(pageProps, prevUrl);
    }

    render() {
        return (
            <img alt="prev-arrow" id="prev-arrow" draggable="false"
                src={require('../../media/images/icons/prev-arrow.png')}
                onClick={() => this.goBack(this.props.pageProps)} />
        );
    }
}

